import { Component, Input, EventEmitter, Output } from '@angular/core';

import { SupporterEditDto, CategoryDto, Language, SyncAndRecurrenceEmit } from '../../../shared/model';
import { SharedService } from '../../../shared/shared.service';

@Component({
  selector: 'app-supporter-data',
  templateUrl: './supporter-data.component.html',
  styleUrls: ['./supporter-data.component.css',
  '../../../shared/styles/confirm-dialog.css',
  '../../../shared/styles/filters.css',
  '../../../shared/styles/translation.css']
})
export class SupporterDataComponent {

  @Input() selectedSupporter: SupporterEditDto;
  @Input() isAdminOnly: boolean;
  @Input() pendingChanges: boolean;
  @Input() supporters: SupporterEditDto[];
  @Input() data: SupporterEditDto[];
  @Input() categories: CategoryDto[];
  @Input() languages: Language[];

  @Output() newSelectedSupporter: EventEmitter<SupporterEditDto> = new EventEmitter();

  newSupporter: SupporterEditDto;
  flags: any;
  changeOpened = false;
  warningOpened = false;
  shouldAddAsRecurrence = false;

  constructor(private sharedService: SharedService) {
    this.flags = this.sharedService.getFlags();

    if (!this.languages || this.languages.length === 0) {
      this.sharedService.getLanguagesTranslations()
        .subscribe(() => {
          this.languages = this.sharedService.getTranslatedLanguages();
        });
    }
   }

  changeSupporterOpen() {
    if (this.pendingChanges === false) {
      this.newSupporter = this.selectedSupporter;
      this.changeOpened = true;
    } else {
      this.warningOpened = true;
    }
  }

  changeClose() {
    this.changeOpened = false;
  }

  changeConfirmed() {
    if (this.newSupporter && this.newSupporter !== this.selectedSupporter) {
      this.newSelectedSupporter.emit(this.newSupporter);
    }
    this.changeClose();
  }

  getSrcForLanguage(languageId: string): string {
    const languageCode = this.getLanguageCode(languageId);

    return this.flags.find(f => f.code === languageCode.toString().toLowerCase()).src;
  }

  isOkDisabled() {
    return this.newSupporter === undefined || this.newSupporter === null;
  }

  handleFilter(value: string) {
    this.data = this.supporters.filter((s) => s.Email.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  warningClose() {
    this.warningOpened = false;
  }

  getLanguageCode(languageId: string) {
    const language = this.languages.find(l => l.Id === languageId);

    return language ? language.LanguageCode : '';
  }

  getLanguageName(languageId: string) {
    const language = this.languages.find(l => l.Id === languageId);

    return language ? language.Name : '';
  }

  getCategoryName(categoryId: string) {
    const category = this.categories.find(c => c.Id === categoryId);

    return category ? category.Name : '';
  }

  recurrenceChange(): void {
    this.shouldAddAsRecurrence = !this.shouldAddAsRecurrence;
  }
}
